// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CloseIcon: React.FC = () => {
    return (
        <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g fill="currentColor">
                    <path
                        d="M28,0 C29.1045695,-2.02906125e-16 30,0.8954305 30,2 L30,28 C30,29.1045695 29.1045695,30 28,30 L2,30 C0.8954305,30 1.3527075e-16,29.1045695 0,28 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L28,0 Z M21.7316804,5.29201235 L14.9996948,12.0252797 L8.2670989,5.29262271 C7.87768807,4.90327291 7.24584153,4.90327291 6.85582033,5.29262271 L5.29201235,6.8564307 C4.90266255,7.24578049 4.90266255,7.87768807 5.29201235,8.26770927 L12.0246693,15.0003052 L5.29201235,21.7329011 C4.90266255,22.1223119 4.90266255,22.7541585 5.29201235,23.1441797 L6.8564307,24.708598 C7.24584153,25.0979478 7.87768807,25.0979478 8.26770927,24.708598 L14.9996948,17.9753307 L21.7322907,24.7079877 C22.1217016,25.0973374 22.7535481,25.0973374 23.1435693,24.7079877 L24.7079877,23.1435693 C25.0973374,22.7541585 25.0973374,22.1223119 24.7079877,21.7322907 L17.9747203,15.0003052 L24.7073773,8.26770927 C25.0967271,7.87829843 25.0967271,7.24645189 24.7073773,6.8564307 L23.1429589,5.29201235 C22.7535481,4.90266255 22.1217016,4.90266255 21.7316804,5.29201235 Z"
                        id="Combined-Shape"
                    ></path>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(CloseIcon);
